<template>
    <v-dialog v-model="dialog" width=900>
        <v-card>
            <v-form ref="formNuevaInterconsulta" v-model="formValid">
                <v-toolbar color="primary" dark dense>
                    <v-toolbar-title>Nueva solicitud para interconsulta</v-toolbar-title>
                    <v-spacer/>
                    <v-btn text @click="cancela">
                        <v-icon>mdi-close-box</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-row class="mt-3" >
                        <v-col cols="12" sm="3">
                            <v-text-field
                                append-icon="mdi-magnify"
                                @click:append="buscarPaciente"
                                v-model="datos.cip"
                                :rules="[
                                    value => !!value || 'Requerido.',
                                    value => value >= 10000010 || 'Este número no es válido',
                                ]"
                                label="Paciente"
                                type="number"
                                filled
                                rounded
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="9" v-if='origen=="cirugia"'>
                            <v-expand-transition>
                                <v-alert text type="warning" v-if="alertError">
                                    {{errorMsg}}
                                </v-alert>
                            </v-expand-transition>
                            <v-expand-transition>
                                <v-alert text type="success" v-if="alertPaciente">
                                    {{pacienteMsg}}
                                </v-alert>
                            </v-expand-transition>
                        </v-col>
                        <v-col cols="12" sm="9">
                            <v-expand-transition>
                                <v-alert text type="info" v-if="pacienteInternado">
                                    {{servicio}}
                                </v-alert>
                            </v-expand-transition>
                            <v-expand-transition>
                                <v-alert text type="info" v-if="pacienteInternado">
                                    {{cama}}
                                </v-alert>
                            </v-expand-transition>
                        </v-col>
                        <v-col cols="12" sm="12">
                            <v-checkbox
                                v-model="datos.urgencia"
                                color="red"
                                label="Urgencia"
                                :disabled="!pacienteValido"
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" >
                            <v-text-field
                                v-model="datos.diagnostico"
                                label="Diagnóstico"
                                rounded
                                filled
                                dense
                                :disabled="!pacienteValido"
                                :rules="[v => !!v || 'Requerido.']"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-textarea
                                class="mr-1"
                                label="Motivo de la interconsulta"
                                v-model="datos.motivo"
                                rounded
                                filled
                                dense
                                :disabled="!pacienteValido"
                                :rules="[v => !!v || 'Requerido.']"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-textarea
                                class="ml-1"
                                label="Resumen"
                                v-model="datos.resumen"
                                rounded
                                filled
                                dense
                                :disabled="!pacienteValido"
                                :rules="[v => !!v || 'Requerido.']"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                            class="mt-0"
                            label="Especialidad a la que se envía"
                            v-model="datos.servicioDestino"
                            rounded
                            filled
                            dense
                            clearable
                            hide-details
                            :disabled="!pacienteValido"
                            :items="$store.state.catalogos.especialidades"
                            item-text="especialidad"
                            item-value="id"
                            @focus="$store.dispatch('catalogos/cargaEspecialidad')"
                            :rules="[v => !!v || 'Requerido.']"
                            />
                        </v-col>
                        <v-col cols="12" sm="6">
                            <select-personal
                                :disabled="!pacienteValido"
                                label="Médico al que se envía"
                                :model.sync="datos.medicoRecibe"
                                :rules="[v => !!v || 'Requerido.']"
                            ></select-personal>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn text color="error" @click="cancela">
                        Cancelar
                    </v-btn>
                    <v-btn color="success" @click="guardaInter" :disabled="!(formValid)" :loading="loadingGuarda">
                        Guardar
                    </v-btn>
                </v-card-actions>
            </v-form>
            <busca-paciente
                :dialogBuscaPaciente.sync="dialogBuscaPaciente"
                :paciente.sync="datos.cip"
                :todos="true"
            ></busca-paciente>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    components:{
        'select-personal':()=>import('@/components/com/SelectPersonal'),
        'busca-paciente':()=>import('@/components/hospital/buscaPaciente'),
    },
    props:{
        dialogModal: Boolean,
        paciente: Number,
        cirugia: Object,

        internamiento:Number,
        consulta: Number
    },

    data:()=>({
        formValid:false,
        datos:{},

        horaModal:false,
        loadingGuarda:false,

        horaAsignadaModal:false,

        // Alertas de pacientes
        alertPaciente:false,
        pacienteInternado:false,
        pacienteMsg:'',
        cama:'',
        servicio:'',

        alertError:false,
        errorMsg:'',

        pacienteValido:false,

        // Para la búsqueda de paciente
        dialogBuscaPaciente:false,
        datosPaciente:{},

        origen:'',

        status:{
            1:{
                color:'blue',
                text:'Solicitada',
            },
            2:{
                color:'green',
                text:'Atendida',
            },
            99:{
                color:'black',
                text:'Cancelada',
            },
        },
    }),

    methods:{
        buscarPaciente(){
            this.datos.cip = null
            this.dialogBuscaPaciente=true
        },
        async guardaInter(){
            this.loadingGuarda = true
            if (!this.datos.urgencia){
                this.datos.urgencia = false
            }
            try{
                let inter = await this.$http({
                    url:'/interconsulta/guarda',
                    method:'POST',
                    params:this.datos,
                })
                this.loadingGuarda = false
                if (inter.data.estado == "true"){
                    this.$emit("guardado")
                    this.$swal.fire({
                        icon: 'success',
                        title: 'Guardado',
                        html: 'Se ha registrado la interconsulta con el folio <h3><b>'+inter.data.root+'</b></h3>',
                    })
                    this.dialog=false

                } else {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No se puede guardar',
                        text: 'Verifique los datos e intente de nuevo',
                    })
                }

            }catch(err){
                this.$store.dispatch('security/revisaError',err)
                this.loadingGuarda = false
            }
            },
        cancela(){
            this.dialog=false
        },
        async revisaPaciente(){
            // si total es 1, pasar, si es 0, mostrar error
            //Hace una petición a pacientes/list y obtener el registro 0
            // De ahi necesitamos en root:
            // internado, debe ser 0
            // internamientoDatos es un objeto que tiene los datos del internamiento (areaNom y cama)
            // tipoRegistro, debe ser 2. Si es 1, notificar para hacer cambio, si es 3, es baja y debe de mostrar error
            // otrosFechaDefuncion, debe ser blanco o null

            this.pacienteValido=false
            try{
                let dp = await this.$http({
                    url:'/pacientes/list',
                    method:'GET',
                    params:{id:this.datos.cip},
                })
                // Si existe el paciente
                if (dp.data.total == 1){
                    let datosP = dp.data.root[0]
                    // Buscar si tiene defuncion
                    if (datosP.otrosFechaDefuncion){
                        this.alertPaciente=false
                        this.pacienteInternado=false
                        this.alertError = true
                        this.errorMsg= 'El paciente '+this.datosP.cip+' está marcado con defunción'
                    }
                    //SI LAS INTERCONSULTAS SOLO SON PARA PACIENTES INTERNADOS
                     /*if (datosP.internado == 0){
                        this.alertPaciente = false
                        this.alertError = true
                        this.errorMsg= 'El paciente no se encuentra internado'
                        this.cama=null
                        this.servicio=null
                    }*/

                    // Si no tiene nada, muestra los datos del paciente
                    if (datosP.otrosFechaDefuncion==''){
                        this.pacienteInternado=false
                        this.alertPaciente=true
                        this.alertError=false
                        this.pacienteMsg=datosP.nombreCompleto + ' ('+ datosP.fechaNacimiento+') ' + datosP.curp
                            if(datosP.internado == 1){
                            this.pacienteInternado=true
                            this.datos.cama=datosP.internadoDatos.cama
                            this.datos.servicioActual=datosP.internadoDatos.area
                            this.cama='Cama: '+datosP.internadoDatos.cama
                            this.servicio='Servicio: '+datosP.internadoDatos.areaNom
                            }
                        this.pacienteValido = true
                    }
                } else {
                    this.alertPaciente=false
                    this.pacienteInternado=false
                    this.alertError = true
                    this.errorMsg='El paciente no existe'
                }

            }catch(err){
                this.$store.dispatch('security/revisaError',err)
            }
        }
    },

    computed:{
        dialog:{
            get(){return this.dialogModal},
            set(val){this.$emit('update:dialogModal',val)}
        }
    },
    watch:{
        dialog(v){
            if (!v){
                this.$refs.formNuevaInterconsulta.reset()
            }
            if(v){
                this.alertPaciente=false
                this.pacienteInternado=false
                this.alertError = false
                if (this.internamiento){
                    this.origen = 'interna'
                }
                if (this.consulta){
                    this.origen = 'consulta'
                }
                if (!this.consulta && !this.internamiento){
                    this.origen = 'cirugia'
                }
                if (this.cirugia){
                    this.origen = 'cirugiaDatos'
                }
            }
        },
        'datos.cip'(val){
            if (val && val >= 10000010){
                this.revisaPaciente()
            }
        },
    },
}
</script>

<style>

</style>